<app-container>
  <div class="mx-auto flex items-end py-md" [formGroup]="formGroup">
    <ng-container *ngIf="((eventService.isFullScreen$ | async) === false) && eventStatus">
      <h1 class="flex-auto mb-0">
        {{ eventStatus.title || 'No Title' }}
        <span class="small block mb-0 text-gray-600" style="margin-bottom: 0 !important;">{{
          online ? 'Currently Live' : 'Offline'
        }}</span>
      </h1>

      <div class="space-x-sm flex flex-row items-end">
        <button class='btn btn-primary' *ngIf='(isCurrentlyStreaming$ | async) && eventStatus.canEdit' (click)='beginBypass()'>
          Bypass
        </button>

        <ng-container *ngIf="(isCurrentlyStreaming$ | async) && eventStatus.canEdit">
          <button class="btn btn-primary" (click)="stopRecording()"><i class="fas fa-pause"></i> Pause</button>
        </ng-container>

        <ng-container *ngIf="!(isCompleted$ | async) && eventStatus.canEdit">
          <button
            class="btn btn-primary"
            *ngIf="!(isCompleted$ | async) && (isPaused$ | async)"
            (click)="startRecording(eventStatus.service, eventStatus.language)"
          >
            <i class="fas fa-play"></i>
            Resume
          </button>
          
          <button class="btn btn-primary"
            *ngIf="(isCurrentlyStreaming$ | async) || (isPaused$ | async)"
            (click)="completeEvent()"
          >
            <i class="fas fa-stop"></i>
            End
          </button>
        </ng-container>

        <button class='btn btn-primary' *ngIf='(isCompleted$ | async)' (click)='downloadSubtitles()'>
          Download Subtitles
        </button>

        <button class="btn btn-primary" *ngIf="eventStatus.canEdit" (click)="editEvent()">
          <i class="fas fa-edit"></i>
          Edit Event
        </button>

        <app-dropdown
          label="Mic Input"
          class="inline-block"
          [options]="this.inputOptions | async"

          [formControlName]="formKeys.selectedMicId"
          [valuePrimitive]="false"
          [style.width]="'300px'"
        >
        </app-dropdown>
      </div>
    </ng-container>
  </div>

  <div
    class="grid grid-flow-col auto-cols-auto eventContainer"
    [style.height]="'calc(100vh - 180px - ' + stenoBoxHeight + 'px)'"
    [ngStyle]="{
      flex: '0 0 ' + (this.appEventHeight$ | async),
      minHeight: 'calc(100vh-172px)'
    }"
    [class.isFullScreen]="eventService.isFullScreen$ | async"
  >
    <app-event
      [window]="1"
      [isCurrentlyStreaming]="isCurrentlyStreaming$ | async"
      [multiWindow]="eventService.isSplitScreen$ | async"
      [class.splitScreen]="eventService.isSplitScreen$ | async"
    ></app-event>

    <app-event
      [window]="2"
      [isCurrentlyStreaming]="isCurrentlyStreaming$ | async"
      [multiWindow]="eventService.isSplitScreen$ | async"
      [class.splitScreen]="true"
      *ngIf="eventService.isSplitScreen$ | async"
      [style.margin-left]="'15px'"
    ></app-event>
  </div>
  <div class="steno" [class.isFullScreen]="eventService.isFullScreen$ | async">
    <app-textfield
      *ngIf="hasStenoPermission"
      placeholder="Notes"
      [class.d-none]="showSteno"
      [formControl]="stenoControl"
      (input)="handleStenoInput($event)"
    ></app-textfield>
  </div>
</app-container>

